import { Button, Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { isDesktop } from './ModalCGU';
import PolicyLink from '../../assets/pdf/PolitiqueConfidentialite.pdf';

const ModalPolicy = (props: any) => {
  const handleClose = () => {
    props.setShow(false);
  };

  return (
    <Modal className="modal-team" show={props.show} onHide={handleClose}>
      <div className="d-flex flex-column justify-content-center m-4 mb-2">
        <div className="mb-1 d-flex flex-row justify-content-between">
          <div className="d-flex flex-row justify-content-start gap-2 mb-0 pb-0">
            <h4 className="short-agenda-modal mt-3 pt-2">
              <p className="fw-bold">Politique de confidentialité : </p>
            </h4>
          </div>
          <Button variant="none" onClick={handleClose}>
            <i className="bi bi-x" style={{ color: '#000D5B', fontSize: '30px' }}></i>
          </Button>
        </div>
        {isDesktop() && <embed className="embed-pdf mb-2" src={PolicyLink} type="application/pdf" />}
        {!isDesktop() && (
          <Link target="_BLANK" className="link" to={PolicyLink}>
            Cliquez ici pour visualisez la politique de confidentialité
          </Link>
        )}
        {props.checkPolicy !== undefined && (
          <Form.Group className="mb-4 mt-4" controlId="PolicyModal">
            <Form.Check
              className="text"
              type="checkbox"
              onChange={() => {
                props.setCheckPolicy(!props.checkPolicy);
                props.changeCheckAll(!props.checkPolicy);
              }}
              checked={props.checkPolicy}
              label="En cochant cette case, je reconnais avoir pris connaissance de la politique de confidentialité de dwell et je les accepte"
            />
          </Form.Group>
        )}
      </div>
    </Modal>
  );
};

export default ModalPolicy;
